import {
  BRAND_IMAGE,
  BRAND_DESCRIPTION,
  BRAND_TAGS,
  BRAND_TITLE,
  BRAND_URL
} from 'constants/brand'

const APP_INITIAL_TEMPLATE = {
  title: BRAND_TITLE,
  description: BRAND_DESCRIPTION,
  tags: BRAND_TAGS.join(','),
  url: BRAND_URL,
  image: BRAND_IMAGE,
  type: 'website'
}

const APP_OPTION = {
  /**
   * Object option used to send the `jwt` String
   * when the user is not authenticated yet.
   * @type {string}
   */
  JWT: 'jwt',
  TRAINING_JWT: 'trainingJwt',
  TRAINING_JTI: 'trainingJti',
  /**
   * Object option, which contains the context response.
   * NOTE: Used by the server in order to update `jwt` cookie if necessary.
   * @type {string}
   */
  CTX_RESPONSE: 'ctxResponse'
}

export {
  APP_INITIAL_TEMPLATE,
  APP_OPTION
}
